import React from 'react';
import { Button, Card, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import TasksTable from './components/TasksTable';
import PageHeader from 'app/components/header/PageHeader';

function Tasks() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Task Pricing | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
      </Helmet>

      <TasksTable />
    </>
  );
}

export default Tasks;
